import Vue from 'vue';
import VueMaskDirective from 'vue-mask-directive';
import Vuelidate from 'vuelidate';

Vue.use(Vuelidate);
Vue.use(VueMaskDirective);
